<div class="grid">
    <div class="col-12">
        <mvs-dm-object-documents-consultant
                [objectIdentifier]="objectIdentifier"
                layoutVariation="contract"
                [showCreateTicketButton]="true"
        ></mvs-dm-object-documents-consultant>
    </div>
</div>




